import {
  APP_TIMEZONE,
  diffCalendarDaysInAppTz,
  parseApiDateTime,
} from "../../../utils/date";

export function formatInboxDate(iso: string): string {
  const date = parseApiDateTime(iso);
  if (Number.isNaN(date.getTime())) return "";

  const now = new Date();
  const diffDays = diffCalendarDaysInAppTz(date, now);
  const tzOptions = { timeZone: APP_TIMEZONE };

  if (diffDays === 0) {
    return date.toLocaleTimeString("en-US", {
      ...tzOptions,
      hour: "numeric",
      minute: "2-digit",
    });
  }
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) {
    return date.toLocaleDateString("en-US", { ...tzOptions, weekday: "short" });
  }

  const dateYear = Number(
    new Intl.DateTimeFormat("en-US", { ...tzOptions, year: "numeric" }).format(
      date,
    ),
  );
  const nowYear = Number(
    new Intl.DateTimeFormat("en-US", { ...tzOptions, year: "numeric" }).format(
      now,
    ),
  );

  if (dateYear === nowYear) {
    return date.toLocaleDateString("en-US", {
      ...tzOptions,
      month: "short",
      day: "numeric",
    });
  }
  return date.toLocaleDateString("en-US", {
    ...tzOptions,
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
